// Brand themes + shared helpers for the Floor Planner tool (Makasa / Julius Mason).

export const BRANDS = {
  julius: {
    name: "Julius Mason",
    tagline: "Planificateur 3D de studio",
    bg: "#FAF8F5", surface: "#FFFFFF", subtle: "#F3EFEA",
    primary: "#B45309", primaryHover: "#92400E", accent: "#D97706",
    text: "#1F2937", muted: "#6B7280", border: "#E5E0D8",
    cta: "Planifier un appel avec Julius",
    ctaUrl: "https://juliusmason.com/contact",
    footerNote: "Outil gratuit proposé par juliusmason.com",
  },
  makasa: {
    name: "Makasa Studio",
    tagline: "Packs meublés pour studios (décret n°2015-981)",
    bg: "#FDFBF7", surface: "#FFFFFF", subtle: "#F7F2EB",
    primary: "#C85A32", primaryHover: "#A84622", accent: "#E07A5F",
    text: "#2C221E", muted: "#786A63", border: "#EADFD5",
    cta: "Commander sur Makasa.fr",
    ctaUrl: "https://makasa.fr/pack-studio",
    footerNote: "Packs livrés et installés par makasa.fr",
  },
};

export const FIT_COLORS = { ok: "#10B981", warn: "#F59E0B", bad: "#EF4444" };

export const WALL_DEFAULTS = { height_m: 2.5, thickness_m: 0.15 };

export const fmtM = (m) => `${Number(m).toFixed(2).replace(".", ",")} m`;

export const cm = (m) => Math.round(Number(m) * 100);

export const fmtEur = (v) =>
  `${Number(v).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export const uid = () => Math.random().toString(36).slice(2, 10);

/** Axis-aligned overlap test between two placed items (rotations approximated). */
export function collides(a, b) {
  const ar = rectOf(a);
  const br = rectOf(b);
  return ar.x1 < br.x2 && ar.x2 > br.x1 && ar.y1 < br.y2 && ar.y2 > br.y1;
}

function rectOf(it) {
  // rotated rectangle's axis-aligned bounding box
  const rad = ((it.rot || 0) * Math.PI) / 180;
  const w = it.wPx, d = it.dPx;
  const rw = Math.abs(w * Math.cos(rad)) + Math.abs(d * Math.sin(rad));
  const rd = Math.abs(w * Math.sin(rad)) + Math.abs(d * Math.cos(rad));
  return { x1: it.x - rw / 2, y1: it.y - rd / 2, x2: it.x + rw / 2, y2: it.y + rd / 2 };
}
